import React, { useEffect, useRef } from 'react';
import { Button } from 'src/components/Inputs';
import CloseS1 from 'plaid-threads/Icons/CloseS1';
// eslint-disable-next-line no-restricted-imports
import IconButton from 'plaid-threads/IconButton';
import styles from './Dialog.module.scss';

interface Props {
  children: React.ReactNode;
  closeButton?: boolean;
  hidden?: boolean;
  onCancel?: () => void;
  onSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
  primaryButtonLabel: string;
  secondaryButtonLabel: string;
  width?: string;
}

const Dialog: React.FC<Props> = ({
  children,
  closeButton = false,
  hidden = false,
  onCancel = () => {
    return undefined;
  },
  onSubmit,
  primaryButtonLabel,
  secondaryButtonLabel,
  width = '945px',
}) => {
  const handleKeyPress = (e) => {
    if (e.key === 'Escape') {
      onCancel();
    }
  };

  const handleOverlayClick = () => {
    if (closeButton) {
      onCancel();
    }
  };

  const stopPropagation = (e) => {
    e.stopPropagation();
  };

  const overlayRef = useRef(null);

  useEffect(() => {
    overlayRef.current.focus();
  });

  // tabIndex and onKeyDown both required for Esc key functionality
  /* eslint-disable jsx-a11y/no-noninteractive-tabindex */
  /* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
  return (
    <div
      className={styles.overlay}
      onClick={handleOverlayClick}
      onKeyDown={handleKeyPress}
      hidden={hidden}
      role='alert'
      ref={overlayRef}
      tabIndex={0}
    >
      <section
        className={styles.root}
        onClick={stopPropagation}
        onKeyDown={handleKeyPress}
        role='dialog'
        aria-modal
        style={{ width: width }}
      >
        <form className={styles.form} onSubmit={onSubmit}>
          {closeButton && (
            <IconButton
              accessibilityLabel='Close dialog'
              icon={<CloseS1 />}
              onClick={onCancel}
              className={styles.cancelButton}
            />
          )}
          <div className={styles.content}>{children}</div>
          <div className={styles.buttons}>
            <div className={styles.dialogGrid}>
              <div className={styles.buttonsCell}>
                <div className={styles.buttonContainer}>
                  <Button
                    fullWidth
                    centered
                    noMinWidth
                    secondary
                    noHref
                    type='button'
                    onClick={onCancel}
                    classes={{ divClassName: styles.buttonDiv }}
                  >
                    {secondaryButtonLabel}
                  </Button>
                  <Button
                    fullWidth
                    centered
                    noMinWidth
                    noHref
                    type='submit'
                    classes={{ divClassName: styles.buttonDiv }}
                  >
                    {primaryButtonLabel}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </section>
    </div>
  );
};

export default Dialog;
